(function(){
  if(window.lwbHPInitialized) return;
  window.lwbHPInitialized = true;

  function initReveal(){
    var els = document.querySelectorAll('.lwb-hp .hp-reveal');
    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target);}
        });
      },{threshold:0.1});
      els.forEach(function(el){io.observe(el);});
    } else {
      els.forEach(function(el){el.classList.add('visible');});
    }
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  window.hpToggleFaq = function(btn){
    var item = btn.closest('.hp-faq-item');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.lwb-hp .hp-faq-item.open').forEach(function(el){el.classList.remove('open');});
    if(!isOpen) item.classList.add('open');
  };
})();
